import {
  ChangeDetectionStrategy,
  Component,
  input,
  output,
} from "@angular/core";
import { FormsModule } from "@angular/forms";
import { SelectItem } from "primeng/api";
import { Checkbox } from "primeng/checkbox";
import { Select } from "primeng/select";
import { SelectedChipsComponent } from "../../chip/selected-chips.component";

// The Requests list's quote type and status filters: a fixed option list, picked with checkboxes.
@Component({
  selector: "app-agent-request-multiselect",
  templateUrl: "./agent-request-multiselect.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [Select, Checkbox, FormsModule, SelectedChipsComponent],
})
export class AgentRequestMultiselectComponent {
  readonly options = input<SelectItem[]>([]);
  readonly placeholder = input("");
  readonly selected = input<string[]>([]);
  readonly selectionChange = output<string[]>();

  public readonly chipLabel = (value: string): string =>
    this.options().find((option) => option.value === value)?.label ?? value;

  public isSelected(value: string): boolean {
    return this.selected().includes(value);
  }

  public remove(value: string): void {
    this.selectionChange.emit(this.selected().filter((item) => item !== value));
  }
}
